<template>
  <div class="bg"></div>
</template>

<script>
export default {
  name: 'NotFound',
  created () {
    document.title = ''
  }
}
</script>

<style scoped>
.bg {
  min-height: 100vh;
  background: linear-gradient(160deg, #e8e8e8 0%, #c8c8c8 100%);
}
</style>

